import React from 'react';
import {
  FDBox, FDIcon, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import {
  EstatePlanningC2BWrapper,
} from 'Views/Page/Content/Modal/Layouts/EstatePlanningC2BLayouts/components/EstatePlanningC2BWrapper';
import FirstYearAmountPicker
  from 'Views/Page/Content/Modal/Layouts/EstatePlanningC2BLayouts/EstatePlanningBuyPayment/Template/Layout/FirstYearAmountPicker/FirstYearAmountPicker';
import useMobileLayout from 'Hooks/useMobileLayout';
import LearnMorePicker
  from './LearnMorePicker/LearnMorePicker';

const EstatePlanningBuyIntroStepLayout = () => {
  const {
    onSubmit,
    saving,
    resource,
  } = useMetaLayoutContext();
  const { displayErrorMessage } = useSnackbarContext();
  const isMobile = useMobileLayout();

  const handleNext = async () => {
    try {
      await onSubmit();
    } catch (err) {
      displayErrorMessage(err, err.errors || 'Failed to load estate plan payment step. Please try again later');
    }
  };

  return (
    <EstatePlanningC2BWrapper>
      <MetaControlField
        attr={'subtitle'}
        hideEmptyFields
      />
      <FDBox paddingY={2}>
        <FDStack direction={isMobile ? 'column' : 'row'} alignItems={isMobile ? 'flex-start' : 'center'} spacing={2}>
          <FDStack direction={'column'} maxWidth={'220px'}>
            <FirstYearAmountPicker resource={resource} />
            <MetaControlField attr={'firstYearText'} />
          </FDStack>
          <FDIcon
            icon={isMobile ? 'keyboardArrowDown' : 'chevronRight'}
            size={'lg'}
            color={'primary'}
          />
          <FDStack direction={'column'}>
            <MetaControlField attr={'recurringPaymentAmount'} />
            <MetaControlField attr={'recurringPaymentText'} />
          </FDStack>
        </FDStack>
      </FDBox>
      <FDBox paddingY={2}>
        <FDStack direction={'row'} alignItems={'flex-start'} spacing={2}>
          <FDPrimaryActionButton
            onClick={async () => handleNext()}
            label={'Buy Now'}
            loading={saving}
          />
          <LearnMorePicker resource={resource} />
        </FDStack>
      </FDBox>
    </EstatePlanningC2BWrapper>
  );
};

EstatePlanningBuyIntroStepLayout.defaultProps = {
};

EstatePlanningBuyIntroStepLayout.propTypes = {
};

export { EstatePlanningBuyIntroStepLayout };
